import { render, staticRenderFns } from "./ConfiguratorLevel1Desktop.vue?vue&type=template&id=b153ede0&scoped=true&"
import script from "./ConfiguratorLevel1Desktop.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorLevel1Desktop.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorLevel1Desktop.vue?vue&type=style&index=0&id=b153ede0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b153ede0",
  null
  
)

export default component.exports